import type { UsuarioSessao } from "@ydchat/shared";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { createContext, useContext, useEffect, type ReactNode } from "react";
import { api, ErroApi } from "./api";

const Contexto = createContext<UsuarioSessao | null>(null);

export const chaveSessao = ["sessao"] as const;

export function useSessaoQuery() {
  return useQuery({
    queryKey: chaveSessao,
    queryFn: async () => {
      try {
        return await api.get<UsuarioSessao>("/auth/sessao");
      } catch (e) {
        if (e instanceof ErroApi && e.status === 401) return null;
        throw e;
      }
    },
    staleTime: 5 * 60_000,
  });
}

export function ProvedorSessao({
  usuario,
  children,
}: {
  usuario: UsuarioSessao;
  children: ReactNode;
}) {
  const qc = useQueryClient();
  useEffect(() => {
    const expirou = () => qc.setQueryData(chaveSessao, null);
    const trocarSenha = () => void qc.invalidateQueries({ queryKey: chaveSessao });
    window.addEventListener("ydchat:sessao-expirada", expirou);
    window.addEventListener("ydchat:trocar-senha", trocarSenha);
    return () => {
      window.removeEventListener("ydchat:sessao-expirada", expirou);
      window.removeEventListener("ydchat:trocar-senha", trocarSenha);
    };
  }, [qc]);
  return <Contexto.Provider value={usuario}>{children}</Contexto.Provider>;
}

export function useUsuario(): UsuarioSessao {
  const u = useContext(Contexto);
  if (!u) throw new Error("useUsuario fora do ProvedorSessao");
  return u;
}
